import { render, staticRenderFns } from "./GmbKeywordsSetting.vue?vue&type=template&id=38c5564c&scoped=true"
import script from "./GmbKeywordsSetting.vue?vue&type=script&lang=js"
export * from "./GmbKeywordsSetting.vue?vue&type=script&lang=js"
import style0 from "./GmbKeywordsSetting.vue?vue&type=style&index=0&id=38c5564c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c5564c",
  null
  
)

export default component.exports